import { inject, Injectable } from '@angular/core';
import { AuthService } from '../../utility-services/auth.service';
import { HttpMainService } from '../../http-main.service';
import { ListModel, ListRequestModel, ReceiptRequestModel, ReceiptResponseModel } from '@itb-monorepo/models';
import { Observable, of } from 'rxjs';
import { ReviewRequestModel} from "@itb-monorepo/models";
import { removeEmptyFields} from "@itb-monorepo/helper";
import { HttpEvent } from '@angular/common/http';


@Injectable()
export class SupporterReceiptsService {
  private _HttpMainService = inject(HttpMainService);
  private authService = inject(AuthService);
  baseUrl = '/finance/';

  getList(params: ListRequestModel): Observable<ListModel<ReceiptResponseModel>> {
    if (!this.authService.hasAccess('receipts:L'))
      return of();

    const url = `${this.baseUrl}v1/receipts`;
    return this._HttpMainService.get(url, removeEmptyFields(params));
  }

  getFinancialListExcel(params: any): Observable<any> {
    if (!this.authService.hasAccess('receipts:L'))
      return of();

    const url = `${this.baseUrl}v1/receipts`;
    return this._HttpMainService.getFile(url, 'application/csv', removeEmptyFields(params));
  }
  review(documentID: string, model: ReviewRequestModel): Observable<ReceiptResponseModel> {
    if (!this.authService.hasAccess('receipts:S'))
      return of();
    return this._HttpMainService.patch(this.baseUrl + "v1/receipts/" + documentID, model);
  }
  getReceiptDetails(receiptId: string): Observable<ReceiptResponseModel> {
    if (!this.authService.hasAccess('receipts:R'))
      return of();
    return this._HttpMainService.get(this.baseUrl + `v1/receipts/${receiptId}`);
  }
  addReceipt(userId: string, model: ReceiptRequestModel): Observable<ReceiptResponseModel> {
    if (!this.authService.hasAccess('receipts:C'))
      return of();
    return  this._HttpMainService.post(this.baseUrl + `v1/users/${userId}/receipts`, model);
  }
  editReceipt(receiptId: string, model: ReceiptRequestModel): Observable<ReceiptResponseModel> {
    if (!this.authService.hasAccess('receipts:U'))
      return of();
    return  this._HttpMainService.put(this.baseUrl + `v1/receipts/${receiptId}`, model);
  }
  addCallBacks(model: any): Observable<HttpEvent<any>>{
    let formData: FormData;
    if (model) {
      formData = new FormData();

      if (model.file)
        formData.append('file', (model.file));

      formData.append('status', model.status);

      if (model.admin_note?.length > 0)
        formData.append('admin_note', model.admin_note);
    }
    return  this._HttpMainService.postFormData(this.baseUrl +
      `v1/gateways/${model.gateway_code}/receipts/${model.receipt_id}/callbacks`, formData);
  }
  getFile(receiptId: string): Observable<any> {
    if (!this.authService.hasAccess('receipts:R'))
      return of();
    return this._HttpMainService.getFile(this.baseUrl + "v1/receipts/" + receiptId + "/files/single");
  }
}
